import { render, staticRenderFns } from "./select-priority.vue?vue&type=template&id=57c1d63d&scoped=true&"
import script from "./select-priority.vue?vue&type=script&lang=js&"
export * from "./select-priority.vue?vue&type=script&lang=js&"
import style0 from "./select-priority.vue?vue&type=style&index=0&id=57c1d63d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c1d63d",
  null
  
)

export default component.exports